<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item   prop="name" label="名称">
                        <el-input v-model="form.name" maxlength="50" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="value" label="值（分）" v-if="sign == 2">
                        <el-input v-model="form.value"  @keyup.native='keyupEvent($event,form.value)' style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="20" type="number" style="width:200px;"></el-input>
                    </el-form-item>
                    <div style="font-size:12px;color:red;" v-if="sign == 2">说明：有值（分）情况就是最后一级，否则还可以继续新增。</div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 

    export default {
        data(){
            return{
                visible: false,
                form:{
                    parentId:"",
                    deptId:"",
                    name:"",
                    value:"",
                    orderNum:"",
                },
                sign:"",
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
            init(data,sign){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                if(sign == 1){
                    this.form.deptId=data.deptId;
                }else if(sign ==2){
                    this.form.deptId=data.attributes.deptId;
                }
                this.form.parentId=data.parentId;
                this.sign=sign;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        let url= this.teacherAssessBaseTypeSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            parentId:(this.form.parentId==undefined)?"":this.form.parentId,
                            type:3,
                            name:this.form.name,
                            value:this.form.value,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));  
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.form.value=e.target.value
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/basis/AddAreaType.vue